import { render } from "./B2bTableRecadvsReceived.vue?vue&type=template&id=4202a12b&scoped=true&lang=pug"
import script from "./B2bTableRecadvsReceived.vue?vue&type=script&lang=js"
export * from "./B2bTableRecadvsReceived.vue?vue&type=script&lang=js"

import "./B2bTableRecadvsReceived.vue?vue&type=style&index=0&id=4202a12b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4202a12b"]])

export default __exports__